import dayjs from 'dayjs'

export const safeResponse = <T>(value: T | undefined | null, defaultValue: T = '-' as T): T => {
  return value ?? defaultValue
}

export const safeBooleanResponse = (value: boolean | undefined): string => {
  return value ? 'Ya' : 'Tidak'
}

export const hasArray = <T>(arr: T[] | undefined): arr is T[] => {
  return Array.isArray(arr) && arr.length > 0
}

export const safeArray = <T>(arr?: T[]): T[] => {
  return hasArray(arr) ? arr : []
}

export const safeString = (value: string | undefined | null, defaultValue = '-'): string => {
  return value === undefined || value === null || value === '' ? defaultValue : value
}

export const safeJoin = <T>(
  arr: T[] | undefined,
  key: keyof T,
  separator = ' & ',
  defaultValue = '-'
): string => {
  return arr?.length ? arr.map((item) => item[key]).join(separator) : defaultValue
}

export const filterTableArray = <T>(arr: T[]): T[] => {
  return hasArray(arr) ? arr : [arr]
}

export const formatFilterDate = (value: string, type: 'START' | 'END') => {
  const payload =
    type === 'START'
      ? dayjs(value).startOf('day').toISOString()
      : dayjs(value).endOf('day').toISOString()
  return dayjs(payload).format('YYYY-MM-DDTHH:mm:ssZ')
}
